import { createNamedWrapperReducer, isActionRelated } from '@core/utils/state';
import { IEntitiesState } from '../shared/entities/entities-state';
import {
    IDriversState,
    initialDriversState
} from './drivers-state';
import { reducer as listReducer } from '../shared/list/reducer';
import { GROUP_DRIVERS } from '../state-groups';
import { DRIVERS_FETCH } from '../action-types';

export function reducer(
    state: IDriversState = initialDriversState(),
    action: any,
    entitySlice: IEntitiesState): IDriversState {        
      
    switch (action.type) {

        case DRIVERS_FETCH:
            return {
                ...state,
                drivers: {
                    ...state.drivers,
                    isFetching: true
                }
            };

        default:
            let nextState: IDriversState = state;

            if (isActionRelated(action, GROUP_DRIVERS)) {
                nextState = {
                    ...state,
                    drivers: createNamedWrapperReducer(
                        listReducer,
                        GROUP_DRIVERS
                    )(state.drivers, action, entitySlice.entities),
                };
            }

            return nextState;
    }
}
